import { render, staticRenderFns } from "./inventory-icon.vue?vue&type=template&id=2f117056&scoped=true"
import script from "./inventory-icon.vue?vue&type=script&lang=js"
export * from "./inventory-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f117056",
  null
  
)

export default component.exports